import type { Cursor } from "./cursor";

export interface Marks {
  readonly entries: ReadonlyMap<string, Cursor>;
}

export const EMPTY_MARKS: Marks = { entries: new Map() };

export function getMark(marks: Marks, name: string): Cursor | undefined {
  return marks.entries.get(name);
}

export function withMark(marks: Marks, name: string, position: Cursor): Marks {
  const entries = new Map(marks.entries);
  entries.set(name, position);
  return { entries };
}
